import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About Island Mobile Marine Service</h1>
          <p>Your trusted marine technician for reliable repairs and professional service</p>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                Island Mobile Marine Service is run by <strong>Jeremy Willoughby</strong>, a hands-on marine 
                technician focused on reliable repairs, clean installs, and straight answers.
              </p>
              <p>
                Mobile service means you don't waste a day hauling the boat around—help comes to you. 
                Whether you're at your dock, marina, or boat storage facility, we bring professional 
                marine repair and maintenance directly to your location.
              </p>
              <p>
                With years of experience working on a wide variety of boats and marine systems, we 
                understand that your time on the water is precious. That's why we're committed to 
                providing fast, reliable service with clear communication every step of the way.
              </p>
            </div>

            <div className="about-highlights">
              <div className="highlight-card">
                <div className="highlight-icon">🔧</div>
                <h3>Expert Technician</h3>
                <p>Skilled in all aspects of marine repair and maintenance</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon">🚤</div>
                <h3>Mobile Service</h3>
                <p>We come to you - no need to transport your boat</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon">💬</div>
                <h3>Clear Communication</h3>
                <p>Honest assessments and straightforward answers</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon">⚡</div>
                <h3>Fast Response</h3>
                <p>Quick scheduling and reliable service</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="values-section">
            <h2 className="section-title">Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Reliability</h3>
                <p>We show up on time and get the job done right. Your time is valuable, and we respect that.</p>
              </div>
              <div className="value-card">
                <h3>Quality Work</h3>
                <p>From diagnostics to repairs to installations, we take pride in doing quality work that lasts.</p>
              </div>
              <div className="value-card">
                <h3>Transparency</h3>
                <p>No surprises. We explain what needs to be done, why it needs to be done, and what it will cost.</p>
              </div>
              <div className="value-card">
                <h3>Customer Service</h3>
                <p>You can actually reach us. We answer calls, respond to messages, and keep you informed.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="why-choose-section">
            <h2 className="section-title">Why Choose Mobile Marine Service?</h2>
            <div className="why-choose-content">
              <div className="why-item">
                <div className="why-number">1</div>
                <div className="why-text">
                  <h3>Save Time</h3>
                  <p>No need to trailer your boat to a shop, wait days for an appointment, and then haul it back. We come to you.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-number">2</div>
                <div className="why-text">
                  <h3>Save Money</h3>
                  <p>Skip the expensive marina fees and boat yard charges. Mobile service is often more affordable than traditional shops.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-number">3</div>
                <div className="why-text">
                  <h3>Stay Informed</h3>
                  <p>Watch the work being done, ask questions, and get immediate answers from the technician working on your boat.</p>
                </div>
              </div>
              <div className="why-item">
                <div className="why-number">4</div>
                <div className="why-text">
                  <h3>Get Back on the Water</h3>
                  <p>Faster turnaround means more time enjoying your boat instead of waiting for repairs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="cta-section">
            <h2>Ready to Work Together?</h2>
            <p>Let's get your boat back in top condition</p>
            <div className="cta-buttons">
              <Link to="/booking" className="btn btn-primary btn-large">Book Service Now</Link>
              <a href="tel:8503230769" className="btn btn-secondary btn-large">📞 850-323-0769</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
